module.exports = __webpack_public_path__ + "img/c-1.9b05b246.svg";